import { Chip, ChipProps } from '@mui/material';
import { styled } from '@mui/material/styles';

// These custom style props drive the CSS below but are not valid DOM
// attributes, so keep them from being forwarded to the underlying element
// (otherwise React warns "does not recognize the `textColor` prop …" for
// every rendered chip).
const CUSTOM_STYLE_PROPS = ['borderColor', 'backgroundColor', 'textColor'];

export const StyledChip = styled(Chip, {
  shouldForwardProp: (prop) => !CUSTOM_STYLE_PROPS.includes(prop as string),
})(
  (props: ChipProps & { borderColor?: string; backgroundColor?: string; textColor?: string }) => `
  border-color: ${props.borderColor};
  background-color: ${props.backgroundColor};
  color: ${props.textColor};
`
);
